/**
 * Student Glass Light Theme
 *
 * Light theme on a flat warm-grey canvas with solid white cards.
 */

import { createGlassTheme } from './create-glass-theme';

export const studentGlassLight = createGlassTheme({
  meta: {
    id: 'student-glass-light',
    name: 'Warm Stone',
    description: 'Light theme with a warm grey canvas and white cards',
    category: 'student',
    mode: 'light',
    previewColors: ['#edecea', '#ffffff', '#f7f7f5', '#c5c5c3'],
  },

  background: {
    base: '#edecea',
    gradient: {
      type: 'linear',
      stops: [
        { color: '#edecea', position: 0 },
        { color: '#edecea', position: 100 },
      ],
    },
    blur: '20px',
    backdropFilter: 'blur(20px) saturate(180%)',
  },

  accent: {
    primary: '#4351a8',
    primaryHover: '#36428c',
    primaryGradient: 'linear-gradient(135deg, #4351a8 0%, #4351a8 100%)',
    primaryGradientHover: 'linear-gradient(135deg, #36428c 0%, #36428c 100%)',
    secondary: '#7c3aed',
    secondaryHover: '#6d28d9',
    secondaryGradient: 'linear-gradient(135deg, #3b1578, #7c3aed, #b4a0f0)',
    secondaryGradientHover: 'linear-gradient(135deg, #2e1060, #6d28d9, #8b5cf6)',
    success: '#059669',
    successStrong: '#065f46',
    warning: '#d97706',
    warningStrong: '#92400e',
    error: '#dc2626',
    info: '#0891b2',
  },

  colors: {
    text: {
      primary: '#23211e',
      secondary: '#636362',
      tertiary: '#6b6a66',
      muted: '#a3a29e',
      inverse: '#fafaf9',
    },
    shadowBase: 'rgba(35, 33, 30',
    shadowOpacity: [0.1, 0.12, 0.15, 0.18],
    accentShadow: '0 8px 16px rgba(67, 81, 168, 0.25)',
    borderBase: 'rgba(35, 33, 30',
    borderOpacity: [0.08, 0.12, 0.18],
    card: {
      background: '#ffffff',
      backgroundHover: '#f7f7f5',
      border: '#e8e8e6',
      shadow: 'none',
    },
    nav: {
      background: '#edecea',
      border: '#c5c5c3',
      shadow: 'none',
      activeBackground: '#ffffff',
      activeText: '#23211e',
    },
    modal: {
      background: '#ffffff',
      border: '#e8e8e6',
      shadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
      backdropColor: 'rgba(0, 0, 0, 0.4)',
    },
    dropdown: {
      background: '#ffffff',
      backgroundHover: '#f7f7f5',
      border: '#e8e8e6',
      shadow: '0 10px 25px -5px rgba(0, 0, 0, 0.15)',
    },
  },

  coverFallback: {
    gradient: 'linear-gradient(135deg, #eceef8 0%, #e3e6f4 100%)',
    text: '#4351a8',
    texture: 'repeating-conic-gradient(#4351a8 0 25%, #c7cce9 0 50%) 0/2px 2px, repeating-conic-gradient(#4351a8 0 25%, #c7cce9 0 50%) 1px 1px/2px 2px',
    textureOpacity: 0.08,
  },
});

export default studentGlassLight;
